(ns machtfit.dashboard.stepchall.form.unit
  (:require [clojure.string :as str]
            [machtfit.dashboard-widgets :as widgets]
            [machtfit.translation :refer [tn]]
            [re-frame.core :as rf]))

(defn- unit-variation [variation language placeholder]
  (let [path [:challenge :config :main-unit variation language]
        value @(rf/subscribe [:get path])]
    [widgets/inline-input
     {:required? false
      :id (str "unit-" (name variation) "-" language)
      :value value
      :placeholder placeholder
      :on-change #(rf/dispatch [:set-path path %])
      :style {:width (str (max 16 (count value)) "ch")
              :font-family "monospace"
              :transition "none"
              :text-decoration "inherit"}}]))

(defn section-unit []
  (let [max-steps-per-day @(rf/subscribe [:get [:challenge :config :max-steps-per-day]])
        {:keys [singular plural]} @(rf/subscribe [:get [:challenge :config :main-unit]])
        unit-str (tn singular plural max-steps-per-day)]
    [widgets/section
     {:anchor "unit"
      :title "Einheit"
      :content [:<>
                [:p "Die Basiseinheit in der die Challenge gewertet wird. Singular- und Pluralformen."]
                [:div.col.s12
                 [:div.col.s6
                  [:table.table.table-bordered {:style {:margin-bottom "1rem"}}
                   [:tbody
                    [:tr
                     [:th "Deutsch"]
                     [:td [unit-variation :singular :de "Schritt"]]
                     [:td [unit-variation :plural :de "Schritte"]]]
                    [:tr

                     [:th "Englisch"]
                     [:td [unit-variation :singular :en "Step"]]
                     [:td [unit-variation :plural :en "Steps"]]]]]]]
                [:div.col.s6
                 [widgets/input-with-label
                  {:required? false
                   :value max-steps-per-day
                   :label-text "Tagesmaximum"
                   :placeholder 100000
                   :type widgets/type-positive-number-or-nil
                   :on-save #(rf/dispatch [:set-path [:challenge :config :max-steps-per-day] %])
                   :style {:width "5.5rem"
                           :margin-right "0.5em"
                           :text-decoration "inherit"}}]
                 (if-not (str/blank? unit-str)
                   unit-str
                   (tn {:en "Step"
                        :de "Schritt"}
                       {:en "Steps"
                        :de "Schritte"}
                       max-steps-per-day))]]}]))
